import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import { HomeMainWrapper } from "./styles";
import Section1 from "./Sections/SectionOne";
import SectionTwo from "./Sections/SectionTwo/index.jsx";
import SectionThree from "./Sections/SectionThree";
export default function Home() {
  return (
    <HomeMainWrapper>
      <Navbar />
      <Section1 />
      <SectionTwo />
      <SectionThree />
      <Footer />
    </HomeMainWrapper>
  );
}
